import { useState, useEffect } from 'react';
import { useQuery } from 'react-query';
import { USER_DETAILS_QUERY_KEY } from '../sharedQueries';

const useIsUsUser = () => {
  const { data: userData } = useQuery(USER_DETAILS_QUERY_KEY);
  const [isUSUser, setIsUSUser] = useState();

  useEffect(() => {
    setIsUSUser(userData?.user?.selected_country?.iso3166alpha2 === 'US');
  }, [userData]);

  return isUSUser;
};

export default useIsUsUser;
